/**
 * Gallery page script
 *
 * Folder-wise lightbox for `page-template/gallery.php`.
 * Uses LightGallery v1 dynamic mode.
 *
 * @package Naari
 */

(function () {
	'use strict';

	function initFolderWiseLightGallery() {
		if (typeof window.jQuery === 'undefined') return;
		if (typeof window.jQuery.fn.lightGallery === 'undefined') return;

		var $ = window.jQuery;
		var selector = '.gallery-item-img[data-lg-images]';

		$(document).off('click.naariGallery', selector);
		$(document).on('click.naariGallery', selector, function (e) {
			e.preventDefault();

			var json = this.getAttribute('data-lg-images');
			if (!json) return;

			var images = [];
			try {
				images = JSON.parse(json);
			} catch (err) {
				return;
			}

			if (!Array.isArray(images) || !images.length) return;

			var $instanceEl = $('<div class="visually-hidden" aria-hidden="true"></div>');
			$('body').append($instanceEl);

			try {
				$instanceEl.lightGallery({
					dynamic: true,
					dynamicEl: images,
					thumbnail: true,
					showThumbByDefault: true,
					animateThumb: true,
					currentPagerPosition: 'middle',
					download: false,
					loop: false,
					closable: true,
					escKey: true,
					keyPress: true,
					hideBarsDelay: 2000,
				});

				var instance = $instanceEl.data('lightGallery');
				if (instance && typeof instance.openGallery === 'function') {
					instance.openGallery(0);
				}
			} catch (err2) {
				$instanceEl.remove();
				return;
			}

			$instanceEl.on('onAfterClose.lg', function () {
				try {
					$instanceEl.data('lightGallery') && $instanceEl.data('lightGallery').destroy(true);
				} catch (err3) {
					// ignore
				}
				$instanceEl.remove();
			});
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		initFolderWiseLightGallery();
	});
})();

